
    <button
      type="button"
      class="btn btn-success"
      style="padding:2px 10px 2px 10px;"
      [disabled]="disabled"
      (click)="onClick()">{{ renderValue }}<i *ngIf="renderIcon" class="{{renderIcon}}"></i></button>
  


// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/detail-renderer-crypto.ts.DetailRendererCrypto.html